import * as xml2js from "xml2js";
export class XmlToJson {
  public static xmlToJson(text: string): any {
    const parser = new xml2js.Parser({ strict: false, trim: true });
    let xml = null;
    parser.parseString(text, (err, result) => {
      xml = result;
    });
    return xml;
  }
}
